/* eslint-disable react/jsx-no-target-blank */
import { useEffect, useState, useRef } from "react"

function ArtistaDettagli({ flag2, artista }) {
    const details = {
        display: 'grid', gridTemplateColumns: '0.25fr 1fr', gap: '5px'
    }
    const [incorpora, setIncorpora] = useState(null)
    const videoPreview = useRef()
    const descrizione = useRef()
    useEffect(() => {
        if (artista.descrizione) {
            descrizione.current.innerHTML = artista.descrizione
            if (artista.incorporaUrl) {
                const url = artista.incorporaUrl
                const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
                const match = url.match(regExp)//ricavo l'ID di 11 cifre dall'URL del video in youtube
                setIncorpora(match[2])
            }
        }
    }, [artista])
    useEffect(() => {
        if (flag2 !== 'artistiDetails') {
            if (artista.video) {
                const lp = videoPreview.current
                lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
            }
        }
    }, [flag2])

    return (<>
        <div className='visualDettagli' style={{ top: `${flag2 === 'artistaDetails' ? '0' : '120%'}`, zIndex: '2' }}>
            {artista.id &&
                <div>
                    <div style={{ padding: '1em 0' }}>
                        <span onClick={() => { window.history.back() }}
                            style={{ marginRight: '1.5em', fontSize: 'xx-large', cursor: 'pointer' }}>◁
                        </span>
                        <h3 style={{ display: 'inline', fontWeight: '600', fontFamily: 'sans-serif', textAlign: 'center' }}>
                            {artista.gruppo ? artista.gruppo : artista.nome ? <span>{artista.nome} {artista?.cognome}</span> : null}
                        </h3>
                    </div>

                    <div style={{ marginBottom: '1rem', clear: 'right' }}><hr />
                        {artista.img ?
                            <img src={`https://leuro-bucket.s3.amazonaws.com/${artista.img}`} style={{ maxWidth: "300px", maxHeight: '300px' }} alt="" />
                            : <img src={require('../image/icons8-impostazioni-amministratore-maschio-32.png')} alt="" />
                        }
                    </div>
                    {artista.nome && artista.cognome &&
                        <div style={details} className='mt-5'>
                            <div>Nome:</div><div><b>{artista.nome} {artista.cognome}</b></div>
                        </div>
                    }
                    {artista.gruppo &&
                        <div style={details}>
                            <div>Gruppo:</div><div><b>{artista.gruppo}</b></div>
                        </div>}
                    <div style={details}>
                        <div>Genere:</div>
                        <div><b>{artista.genere}</b>
                            <div><i>{artista.soggetto}</i></div>
                        </div>
                    </div>
                    {artista.numero &&
                        <div style={details}>
                            <div>N. comp:</div><div><b>{artista.numero} {artista.numero > 1 ? 'elementi' : 'elemento'}</b></div>
                        </div>
                    }
                    {artista.cachet &&
                        <div style={details}>
                            <div>Cachet:</div><div> € <b>{artista.cachet}</b></div>
                        </div>
                    }
                    {artista.città &&
                        <div style={details}>
                            <div>Città:</div><div><b>{artista.città}</b></div>
                        </div>
                    }
                    {artista.regione &&
                        <div style={details}>
                            <div>Regione:</div><div><b>{artista.regione}</b></div>
                        </div>
                    }
                    {artista.durata && <div>Durata show: <b> {artista.durata}</b></div>}

                    <div style={{ ...details, marginTop: '10px' }}>
                        <div>Email:</div><div>{artista.emailUser}</div>
                    </div>
                    {artista.telefono !== '' &&
                        <div style={details}>
                            <div>Telefono:</div><div><b>{artista.telefono}</b></div>
                        </div>
                    }
                    {/* ------------------------ DESCRIZIONE---------------------- */}
                    <p ref={descrizione} style={{ border: '2px solid lightblue', fontWeight: '500', backgroundColor: '#fffcfc', padding: '20px 10px', marginTop: '1em' }} />

                    {/* ------------------------- VIDEO ----------------------- */}
                    {artista.video &&
                        <div className='mt-5' style={{ border: '1px solid lightgrey', borderRadius: '5px', padding: '0 5px' }}>
                            <div className='text-center mt-3'>
                                <video src={`https://leuro-bucket.s3.amazonaws.com/video/${artista.video}`} ref={videoPreview}
                                    style={{ width: '100%', maxHeight: '400px', borderRadius: '5px' }} controls />
                            </div>
                        </div>
                    }

                    {/* ---------------------- INCORPORA VIDEO -------------------- */}
                    {artista.incorporaUrl !== null && incorpora &&
                        <iframe className='mt-4' key={flag2}
                            src={`https://www.youtube.com/embed/${incorpora}?si=nI26l5QmqMrpYujf`}
                            style={{ width: '100%', height: '350px' }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="YouTube Video Player"
                        />
                    }

                    <div style={{ border: '1px solid lightgrey', borderRadius: '20px', padding: '10px 5px', marginTop: '2rem' }}>
                        <h5 style={{ fontFamily: 'sans-serif' }}>LINK</h5>
                        {artista.url &&
                            <a href={artista.url} target='_blank'>
                                <img src={require('../image/icons8-sito-web-30.png')} alt="" />
                            </a>
                        }
                        {artista.fb &&
                            <a href={artista.fb} className="ms-2" target='_blank'>
                                <img src={require('../image/icons8-fb-48.png')} alt="" width={35} />
                            </a>
                        }
                        {artista.youtube &&
                            <a href={artista.youtube} className='ms-2' target='_blank'>
                                <img src={require('../image/icons8-youtube-48.png')} alt="" />
                            </a>
                        }
                        {!artista.url && !artista.fb && !artista.youtube &&
                            <div>Nessun link presente </div>
                        }
                        <p className='p-1 ms-2 mt-1' style={{ width: 'fit-content', backgroundColor: 'lightgray', borderRadius: '5px' }}>{artista.view} view</p>
                    </div>

                    <div className='mt-5' style={{ marginBottom: '2rem' }}>
                        <button className='btn btn-secondary'
                            onClick={() => {
                                if (artista.video) {
                                    const lp = videoPreview.current
                                    lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
                                }
                                window.history.back()
                            }}>Indietro
                        </button>
                    </div>
                </div>
            }
        </div>
    </>)
}
export default ArtistaDettagli